import { Controller } from 'stimulus';
import Swiper, {Pagination, EffectFade} from 'swiper'
import throttle from 'lodash/throttle'

Swiper.use([Pagination, EffectFade])

export default class extends Controller {
  static targets = ['slider', 'pagination']

  get gallerySlider() {
    return document.querySelector('.gallery__slider');
  }

  get article() {
    return document.querySelector('.article');
  }

  get open_overlay() {
    return document.querySelector('.overlay__open');
  }

  get header() {
    return document.querySelector('.article__header');
  }

  get footer() {
    return document.querySelector('.article__footer');
  }

  get content() {
    return document.querySelector('.article__content');
  }

  get shareLink() {
    return document.querySelector('.share--link');
  }

  connect() {
    // Handle the window resize event
    // this will destroy the slider if it exists,
    // and then re-initialize it based on the window width
    this.handleResize()
    window.addEventListener('resize', throttle(this.handleResize.bind(this), 250))
  }

  disconnect() {
    window.removeEventListener('resize', throttle(this.handleResize, 250))
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
  }

  /**
   * Handle the window resize event -
   * This will destroy the slider if it exists, and then re-initialize it.
   * @returns {void}
   */
  handleResize() {
    if (this.header.offsetHeight > 110) {
      // change the height of the scrollable area
      let footerTop = this.footer.getBoundingClientRect().top
      let contentTop = this.content.getBoundingClientRect().top
      let maxHeight = parseInt(footerTop - contentTop);
      let diff = this.header.offsetHeight - 110;
      let height = parseInt(maxHeight) - diff + "px";
      console.log({height, diff, maxHeight, footerTop, contentTop})
      this.content.style.maxHeight = height;
      this.setLinkFocus();
    }

    // if the slider exists, destroy it
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
    // re-initialize the slider
    this.initSlider()
  }

  /**
   * Initialize the slider -
   * This will initialize the slider based on the window width
   */
  initSlider() {
    // get the window width
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    // if the window width is less than 768px, initialize the slider
    if (windowWidth < 1024) {
      this.initGallerySlider()
    }
  }

  /**
   * Initialize the gallery slider -
   * We will show a slider for the gallery images
   */
  initGallerySlider() {
    this.swiper = new Swiper(this.sliderTarget, {
      slidesPerView: 1,
      centeredSlides: true,
      speed: 400,
      effect: 'fade',
      autoHeight: true,
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: this.paginationTarget,
        clickable: true,
      },
    })
  }

  setLinkFocus() {
    if (this.shareLink) {
      this.shareLink.focus(() => {
        document.querySelector('.share__links').classList.add('share__links--fade');
      });
    }
  }
}
